import store from '@/store';

const APP_VERSION = 'v3.7.41';

let cachedLocation = null;

export function getAppType() {
  const uA = navigator.userAgent || navigator.vendor || window.opera;
  if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'IOS';
  if (/android/i.test(uA)) return 'ANDROID';

  const urlParams = new URLSearchParams(window.location.search);
  const t = urlParams.get('t');
  if (t === 'ios') return 'IOS';
  if (t === 'android') return 'ANDROID';

  return null;
}

export function startLocationTracking() {
  if (!navigator.geolocation) return;

  navigator.geolocation.getCurrentPosition(
    (position) => {
      cachedLocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        accuracy: position.coords.accuracy
      };
    },
    () => {},
    { timeout: 10000, maximumAge: 60000 }
  );
}

export function getCachedLocation() {
  return cachedLocation;
}

export function getMediaMetadata() {
  try {
    const location = getCachedLocation();
    let fingerprint = null;
    try {
      fingerprint = store?.getters?.['Auth/fingerprint'] || null;
    } catch (e) {
      console.warn('[mediaMetadata] Erro ao obter fingerprint:', e);
    }

    return {
      app_type: getAppType(),
      app_version: APP_VERSION,
      location_lat: location?.lat ?? null,
      location_lng: location?.lng ?? null,
      location_accuracy: location?.accuracy ?? null,
      device_fingerprint_hash: fingerprint
    };
  } catch (e) {
    console.error('[mediaMetadata] Erro ao montar metadata:', e);
    return {
      app_type: null,
      app_version: APP_VERSION,
      location_lat: null,
      location_lng: null,
      location_accuracy: null,
      device_fingerprint_hash: null
    };
  }
}

export function appendMetadataToFormData(formData) {
  const metadata = getMediaMetadata();
  Object.entries(metadata).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, String(value));
    }
  });
  return formData;
}

export function getMetadataForJson() {
  const metadata = getMediaMetadata();
  const result = {};
  Object.entries(metadata).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      result[key] = value;
    }
  });
  return result;
}
